import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {initialState} from '@/store/states/descriptions'
import {
  DescriptionsMap,
  writeStoredDescriptions,
} from '@/helpers/stockDescriptions'

export const slice = createSlice({
  name: 'descriptions',
  initialState,
  reducers: {
    SET_DESCRIPTIONS: (state, {payload}: PayloadAction<DescriptionsMap>) => {
      if (Object.keys(payload).length === 0) return
      state.byId = {...state.byId, ...payload}
      writeStoredDescriptions(state.byId)
    },
  },
})

export const {SET_DESCRIPTIONS} = slice.actions

export default slice.reducer
